import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { AuthGuard } from './auth.guard';
import { UPUnauthorizedComponent } from 'up';
import { ErrorComponent } from './shared/components/error/error.component';
const routes: Routes = [
  {
    path: 'product',
    loadChildren: () =>
      import('./instructor/instructor.module').then((m) => m.InstructorModule),
    canActivate: [AuthGuard],
    data: { authorizedRole: 'instructor' },
  },
  {
    path: 'assignment',
    loadChildren: () =>
      import('./learner/learner.module').then((m) => m.LearnerModule),
    canActivate: [AuthGuard],
    data: { authorizedRole: 'learner' },
  },
  {
    path: '',
    component: AppComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'unauthorized',
    component: UPUnauthorizedComponent,
  },
  {
    path: '**',
    component: ErrorComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
